const initialState = {
  isLoading: false,
  items: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UPSELL_ITEMS_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case 'UNSET_UPSELL_ITEMS_LOADING':
      return {
        ...state,
        isLoading: false,
      };
    case 'RECEIVE_UPSELL_ITEM': {
      return {
        ...state,
        items: [...state.items, action.item],
      };
    }
    default:
      return state;
  }
};
